// Form1.js
import React, { useState, useEffect } from 'react';
import ChatBox from '../../custom_elements/ChatBox';
import {CustomInput, validationRules} from '../../custom_elements/CustomInput';
import Product from '../../custom_elements/Product';
import axios from 'axios';

export default function Form5({ nextForm, call, products, callDone }) {

    const formatEuroNumber = (value) => {
      return value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    return (
        <>
        <div className="formFieldBox" style={{alignItems: "start", alignContent: "start", justifyContent: "start", justifyItems: "start"}}>
            <a className="toggleButton">
                LÖSUNGSVORSCHLÄGE
            </a>
            <div className="formFieldContent"  style={{alignSelf: "left", marginLeft: "10px"}}>
                <div className="formFieldContentInner">

                    {(products.length > 0 && callDone == 1) && <>
                    <p>
                    <b>JUCHHU du kannst dir deinen Wohntraum leisten!</b><br />
                    Mit den eingegebenen Daten zur Liegenschaft und deinem Kreditwunsch (Höhe, Laufzeit und Produkt) ergibt sich ein Finanzierungsbedarf
                    in Höhe von  {formatEuroNumber(products[0]["kreditbetrag"])}€ (zuzüglich Nebenkosten des Kredits). Bei den nachfolgenden Instituten ist eine Finanzierung vorstellbar.
                    Wenn du mehr Details zu den Angeboten sehen möchtest, klicke auf Details.
                    </p></>}
                    {(products.length == 0 && callDone == 1) && <>
                    <p>
                    Leider geht sich mit den eingegebenen Daten kein Kredit aus. Prüfe doch folgende Möglichkeiten:
                    <ul>
                    <li>Kannst du mehr Eigenmittel einbringen zB. aus Reserven?</li>
                    <li>Kannst du eine zusätzliche Person hinzufügen, sodass gesamt mehr Einkommen zur Verfügung steht?</li>
                    <li>Kannst du eine günstigere Immobilie wählen?</li>
                    </ul>
                    </p></>}
                </div>
            </div>
        </div>
        </>
    );
}
